import { render, staticRenderFns } from "./ModelGroupModal.vue?vue&type=template&id=c97d6a9c&scoped=true"
import script from "./ModelGroupModal.vue?vue&type=script&lang=js"
export * from "./ModelGroupModal.vue?vue&type=script&lang=js"
import style0 from "./ModelGroupModal.vue?vue&type=style&index=0&id=c97d6a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d6a9c",
  null
  
)

export default component.exports